export const PRESET_THEMES = [
  {
    id: 'fcp',
    label: 'Finding Common Purpose',
    primaryColor: '#2d6b49',
    accentColor: '#c8614a',
    backgroundColor: '#f0fbff',
    fontHeading: 'Playfair Display',
    fontBody: 'Inter',
    logoSrc: '/logo-fcp.svg',
    logoAlt: 'Finding Common Purpose'
  },
  {
    id: 'north-arrow',
    label: 'North Arrow',
    primaryColor: '#1c3557',
    accentColor: '#e63947',
    backgroundColor: '#f2f8ee',
    fontHeading: 'Poppins',
    fontBody: 'Open Sans',
    logoSrc: '/logo-na.png',
    logoAlt: 'North Arrow'
  }
];

export default function ThemeTab({ selected, onSelect, custom, onCustomChange }) {
  function handleLogoUpload(e) {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = evt => onCustomChange({ ...custom, logoDataUrl: evt.target.result });
    reader.readAsDataURL(file);
  }

  return (
    <div className="theme-tab">
      <div className="theme-cards">
        {PRESET_THEMES.map(theme => (
          <button
            key={theme.id}
            className={`theme-card${selected === theme.id ? ' theme-card--active' : ''}`}
            onClick={() => onSelect(theme.id)}
            type="button"
          >
            <div className="theme-card-swatches">
              <span className="theme-swatch" style={{ background: theme.primaryColor }} title={theme.primaryColor} />
              <span className="theme-swatch" style={{ background: theme.accentColor }} title={theme.accentColor} />
              <span className="theme-swatch theme-swatch--light" style={{ background: theme.backgroundColor }} title={theme.backgroundColor} />
            </div>
            <div className="theme-card-logo-wrap">
              <img src={theme.logoSrc} alt={theme.logoAlt} className="theme-card-logo" />
            </div>
            <div className="theme-card-label">{theme.label}</div>
            {selected === theme.id && <div className="theme-card-selected-badge">✓ Active</div>}
          </button>
        ))}

        {/* Custom theme card */}
        <button
          className={`theme-card theme-card--custom${selected === 'custom' ? ' theme-card--active' : ''}`}
          onClick={() => onSelect('custom')}
          type="button"
        >
          <div className="theme-card-swatches">
            <span className="theme-swatch" style={{ background: custom.primaryColor }} title={custom.primaryColor} />
            <span className="theme-swatch" style={{ background: custom.accentColor }} title={custom.accentColor} />
            <span className="theme-swatch theme-swatch--light" style={{ background: custom.backgroundColor }} title={custom.backgroundColor} />
          </div>
          <div className="theme-card-logo-wrap">
            {custom.logoDataUrl
              ? <img src={custom.logoDataUrl} alt="Custom logo" className="theme-card-logo" />
              : <span className="theme-card-logo-placeholder">+ Logo</span>
            }
          </div>
          <div className="theme-card-label">Custom</div>
          {selected === 'custom' && <div className="theme-card-selected-badge">✓ Active</div>}
        </button>
      </div>

      {selected === 'custom' && (
        <div className="theme-custom-editor">
          <h4 className="theme-custom-heading">Customize colors &amp; logo</h4>

          <div className="theme-custom-row">
            <label className="theme-custom-label">Header color</label>
            <div className="theme-custom-inputs">
              <input
                type="color"
                value={custom.primaryColor}
                onChange={e => onCustomChange({ ...custom, primaryColor: e.target.value })}
                className="theme-color-picker"
              />
              <input
                type="text"
                value={custom.primaryColor}
                onChange={e => onCustomChange({ ...custom, primaryColor: e.target.value })}
                className="theme-hex-input"
                maxLength={7}
                spellCheck={false}
              />
            </div>
          </div>

          <div className="theme-custom-row">
            <label className="theme-custom-label">Accent color</label>
            <div className="theme-custom-inputs">
              <input
                type="color"
                value={custom.accentColor}
                onChange={e => onCustomChange({ ...custom, accentColor: e.target.value })}
                className="theme-color-picker"
              />
              <input
                type="text"
                value={custom.accentColor}
                onChange={e => onCustomChange({ ...custom, accentColor: e.target.value })}
                className="theme-hex-input"
                maxLength={7}
                spellCheck={false}
              />
            </div>
          </div>

          <div className="theme-custom-row">
            <label className="theme-custom-label">Background</label>
            <div className="theme-custom-inputs">
              <input
                type="color"
                value={custom.backgroundColor}
                onChange={e => onCustomChange({ ...custom, backgroundColor: e.target.value })}
                className="theme-color-picker"
              />
              <input
                type="text"
                value={custom.backgroundColor}
                onChange={e => onCustomChange({ ...custom, backgroundColor: e.target.value })}
                className="theme-hex-input"
                maxLength={7}
                spellCheck={false}
              />
            </div>
          </div>

          <div className="theme-custom-row theme-custom-row--logo">
            <label className="theme-custom-label">Logo</label>
            <div className="theme-custom-inputs">
              <label className="theme-logo-upload-btn">
                {custom.logoDataUrl ? 'Replace logo' : 'Upload logo'}
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleLogoUpload}
                  style={{ display: 'none' }}
                />
              </label>
              {custom.logoDataUrl && (
                <button
                  type="button"
                  className="theme-logo-remove"
                  onClick={() => onCustomChange({ ...custom, logoDataUrl: null })}
                >
                  Remove
                </button>
              )}
            </div>
            {custom.logoDataUrl && (
              <div className="theme-logo-preview">
                <img src={custom.logoDataUrl} alt="Logo preview" />
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
